<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary" @click="exportData" v-loading="exportButtonLoading" :disabled="exportButtonLoading">导出</el-button>

          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <el-button class="btn primary" type="primary" style="margin-right: 10px"
          @click="showTransfer">自定义设置</el-button>
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <div v-if="tableHaeder.length>0">
        <CustomTable  ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
        @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name"> 
        <template slot="before">
          <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
          </el-table-column>
        </template>
          <template slot="after">
            <el-table-column fixed="right" prop="operation" label="标签详情" width="100">
              <template slot-scope="scope">
                <el-button type="text" v-if="scope.row.hasTagCode==1"  v-preventReClick class="color-blue" @click="tagCodeView(scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </template>
        </CustomTable>
      </div>
      <div v-else>
        <el-table ref="multipleTable" border v-loading="loading" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
          <template slot="empty">
            <div class="empty-div" :style="{ height: tableHeight + 'px' }">
              <img src="../../../../assets/noData.png" width="240" height="240" />
              <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
              <div class="empty-rest" @click="reset">恢复默认</div>
            </div>
          </template>
          <el-table-column fixed prop="tableTypeName" width="120" label="单据类型"></el-table-column>
          <el-table-column prop="tableNo" width="170" label="单据编号"></el-table-column>
          <el-table-column prop="inOutTypeName" width="100" label="出入库类型"></el-table-column>
          <el-table-column prop="supplierProductNo" width="170" label="供应商产品编码" show-overflow-tooltip></el-table-column>
          <el-table-column prop="productName" show-overflow-tooltip width="130" label="产品"></el-table-column>
          <el-table-column prop="specName" show-overflow-tooltip width="130" label="规格/型号"></el-table-column>
          <el-table-column prop="supplierName" show-overflow-tooltip width="120" label="供应商"></el-table-column>
          <el-table-column prop="manufacturerName" show-overflow-tooltip width="120" label="生产厂家"></el-table-column>
          <el-table-column prop="warehouseName" show-overflow-tooltip width="100" label="库房"></el-table-column>
          <el-table-column prop="locationName" show-overflow-tooltip width="70" label="货位">
            <template slot-scope="scope">
              {{scope.row.locationName?scope.row.locationName:'-'}}
            </template>
          </el-table-column>
          <el-table-column prop="number" width="80" label="数量"></el-table-column>
          <el-table-column prop="price" width="80" label="单价"></el-table-column>
          <el-table-column prop="unit" width="80" label="包装单位">
            <template slot-scope="scope">
              {{scope.row.unit?scope.row.unit:'-'}}
            </template>
          </el-table-column>
          <el-table-column prop="minUnit" width="80" label="最小单位"></el-table-column>
          <el-table-column prop="amount" width="80" label="金额"></el-table-column>
          <el-table-column prop="packSpec" width="100" label="包装规格"></el-table-column>
          <el-table-column prop="createdTime" width="170" label="创建时间">
            <template slot-scope="scope">
              {{ parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }}
            </template>
          </el-table-column>
          <el-table-column prop="createdUserName" width="100" label="操作人"></el-table-column>
          <el-table-column prop="ownerDeptName" width="100" label="所属科室"></el-table-column>
          <el-table-column prop="validityDate" width="120" label="有效期">
            <template slot-scope="scope">
              {{scope.row.validityDate?parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d}"):'-'}}
            </template>
          </el-table-column>
          <el-table-column prop="longTime" label="长期" width="60">
            <template slot-scope="scope">
              {{ scope.row.longTime == 1 ? "是" : "否" }}
            </template>
          </el-table-column>
          <el-table-column prop="batch" width="100" label="批号" show-overflow-tooltip></el-table-column>
          <el-table-column prop="manufactureDate" width="120" label="生产日期">
            <template slot-scope="scope">
              {{scope.row.manufactureDate?parseTime(new Date(scope.row.manufactureDate), "{y}-{m}-{d}"):'-'}}
            </template>
          </el-table-column>
          <el-table-column prop="serialNo" width="100" label="序列号" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.serialNo?scope.row.serialNo:'-'}}
            </template>
          </el-table-column>
          <el-table-column prop="mainNo" width="100" label="主条码" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.mainNo?scope.row.mainNo:'-'}}
            </template>
          </el-table-column>
          <el-table-column prop="onlineNo" width="100" label="挂网号" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.onlineNo?scope.row.onlineNo:'-'}}
            </template>
          </el-table-column>
          <el-table-column prop="productRegistCertName" width="100" label="注册证名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="productRegistCertNo" width="100" label="注册证号" show-overflow-tooltip></el-table-column>
          <el-table-column prop="traceNo" width="100" label="溯源码" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.traceNo?scope.row.traceNo:'-'}}
            </template>
          </el-table-column>
          <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码" width="200"></el-table-column>
          <el-table-column fixed="right" prop="operation" label="标签详情" width="100">
            <template slot-scope="scope">
              <el-button type="text" v-if="scope.row.hasTagCode==1"  v-preventReClick class="color-blue" @click="tagCodeView(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
   
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
    <LabelDetailsDialog v-if="labelDetailsVisible" :open="labelDetailsVisible" :data="labelDetailsData" 
    @tagCodeDelete="tagCodeDelete"
    @close="closeLabelDetailsDialog"/>
    <PackageLabelDialog v-if="packageLabelVisible" :open="packageLabelVisible" :data="packageLabeData"
    @viewDetails="viewDetails"
     @tagCodeDelete="tagCodeDelete"
     @close="closePackageLabelDialog"/>
     <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import {
  GetInOutStockLog,
  ExportInOutStockLog,
  GetTagCodeList
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  InOutStockTypeOptions,
  InOutTableTypeOptions
} from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from "@/mixin/baseList-mixin.js";
import LabelDetailsDialog from "@/components/labelDetails-dialog";
import PackageLabelDialog from "@/components/packageLabel-dialog";
export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
    LabelDetailsDialog,
    PackageLabelDialog,
  },
  data () {
    return {
      GetDatasAction: GetInOutStockLog,
      // RemoveAction: RemoveAcceptOutStock,
      // PrintAction: GetAcceptOutStockPrintData,
      // editPath: 'accept-out-stock-edit',
      exportAction: ExportInOutStockLog,

      InOutStockTypeOptions: InOutStockTypeOptions,
      InOutTableTypeOptions: InOutTableTypeOptions,
      filterOptions: [{
        name: "单号",
        type: "input",
        code: "keyWord",
      },
      {
        name: "供应商产品编码",
        type: "input",
        code: "supplierProductNo",
      },
      {
        name: "产品名称",
        type: "input",
        code: "productName",
      },
      {
        name: "规格型号",
        type: "input",
        code: "specName",
      },
      {
        name: "库房",
        type: "select",
        code: "warehouseId",
        filterMethod: this.getWarehouses,
        data: [],
      },
      {
        name: "供货商产品",
        type: "select",
        code: "productId",
        filterMethod: this.getSupplierProductsNoDebounce,
        data: [],
      },
      {
        name: "供应商",
        type: "select",
        code: "supplierId",
        filterMethod: this.getSuppliers,
        data: [],
      },
      {
        name: "溯源码",
        type: "input",
        code: "traceNo",
      },
      {
        name: "批号",
        type: "input",
        code: "batch",
      },
      {
        name: "出入库类型",
        type: "select",
        code: "inOutType",
        data: InOutStockTypeOptions,
      },
      {
        name: "单据类型",
        type: "select",
        code: "TableTypes",
        multiple: true,
        data: InOutTableTypeOptions,
      },

      {
        name: "创建时间",
        type: "datetime",
        code: "date",
        format: "yyyy-MM-ddhh:mm:ss",
      },
      {
        name: "医保代码",
        type: "input",
        code: "medicalInsuranceCategoryNo",
      },
      {
        name: "注册证号",
        type: "input",
        code: "productRegistCertNo",
      },
      // {
      //   name: "主条码",
      //   type: "input",
      //   code: "mainNo",
      // },
      ],
    };
  },
  methods: {
    tagCodeView (row) {
      let data ={
        supplierProductId:row.supplierProductId,
        traceNo:row.traceNo,
        mainNo:row.mainNo,
        validityDate:row.validityDate,
        manufactureDate:row.manufactureDate,
        batch:row.batch,
        serialNo:row.serialNo,
        logTableNo:row.tableNo,
        locationId:row.locationId,
      }
      GetTagCodeList(data).then((res) => {
        this.labelDetailsVisible = true;
        this.labelDetailsData = res.returnData;
      });
      // this.labelDetaiPaternity = row
      // if (row.itemTagCodeViewModels && row.itemTagCodeViewModels.length > 0) {
      //   this.packageLabeData = { data: row.itemTagCodeViewModels }
      //   this.packageLabelVisible = true
      // } else {
      //   this.labelDetailsVisible = true
      //   this.labelDetailsData = { data: row.tagCodeViewModels }
      // }
    },
    closeLabelDetailsDialog () {
      this.labelDetailsVisible = false
      this.labelDetailsData = {}
    },
    closePackageLabelDialog () {
      this.packageLabelVisible = false
      this.packageLabeData = {}
      this.labelDetailsData = {}
    },
    tagCodeDelete (row) {
      this.form.details.filter(res => res == this.labelDetaiPaternity)[0].tagCodeViewModels = row
      this.form.details.filter(res => res == this.labelDetaiPaternity)[0].number--
      this.form.details.filter(res => res == this.labelDetaiPaternity)[0].amount = this.form.details.filter(res => res == this.labelDetaiPaternity)[0].number * this.form.details.filter(res => res == this.labelDetaiPaternity)[0].price
      this.autoTotalAmount()
    },
  },
  created () {
    if (this.$route.query) {
      this.$nextTick(() => {
        this.query = {
          ...this.query,
          ...this.$route.query
        };
        this.getData();
      });
      this.query = {
        ...this.query,
        ...this.$route.query
      };
    }
  },
  mounted () {
    let date = [
    this.parseTime(new Date(new Date().getFullYear(),new Date().getMonth()-1,new Date().getDate()), "{y}-{m}-{d} {h}:{i}:{s}"),this.parseTime(new Date(), "{y}-{m}-{d} {h}:{i}:{s}") 
    ]
    this.$set(this.query,'date',date)
    this.query.startDate = this.query.date[0]
    this.query.endDate = this.query.date[1]
   },
};
</script>

<style lang="scss" scoped></style>
